<template>
    <v-app id="inspire">
        <div>
            <div class="details-header">
                <div class="details-header-back">
                    <p class="header-title title-name mb-0">Job ID:<span class="title-response headline"> {{ job_id }} </span><br>
                        <span class="upp"> {{ full_name }} </span> 
                        <template v-if="pricing_plan_name">
                            on <span class="upp"> {{ pricing_plan_name }} </span> 
                            <template v-if="service_plan_name">
                            - {{ service_plan_name }}
                            </template>
                        </template>
                    </p>                         
                    <v-btn class="header-btn-back mr-0 mb-3" @click="$router.go(-1)">
                    <v-icon class="header-btn-back-icon">navigate_before</v-icon>
                        Back
                    </v-btn>
                </div>
                <div style="clear: both;"></div>
                <v-layout xs12>
                    <div v-if="items.length > 0 && !no_data.includes(items[0].status_name)" class="mt-4" :class="'job-status-' + items[0].status_name">                        
                        <div class="subscriptions-status-text">
                            <span>{{makeCapitalFirstLetter(items[0].status_name)}}</span>
                        </div>
                    </div>
                    <v-spacer></v-spacer>
                    <v-menu offset-y bottom left
                         v-if="items[0] && (['completed', 'dispatched', 'skipped'].includes(items[0].status_name) || displayAssignSkipped)"
                    >
                        <template v-slot:activator="{ on }">
                        <v-btn
                            large
                            v-on="on"
                            color="#00838F"
                            dark
                            class="mr-0 ml-1 px-4"
                        >
                            Actions <v-icon right>keyboard_arrow_down</v-icon>
                        </v-btn>
                        </template>
                      <v-list style="cursor: pointer;">
                            <v-list-item 
                                v-if="items[0] && items[0].status_name === 'completed'"
                                @click="vEmit({ name: 'RecleanJob', data: selected })"
                            >
                              <v-list-item-title><v-icon color="red" class="mr-2">replay</v-icon> Reclean Job</v-list-item-title>
                            </v-list-item>
                            <v-list-item 
                                v-if="items[0] && ['skipped', 'dispatched'].includes(items[0].status_name)"
                                @click="vEmit({ name: 'DeleteJob', data: selected })"
                            >
                                <v-list-item-title><v-icon color="red" class="mr-2">delete</v-icon> Delete Job</v-list-item-title>
                            </v-list-item>
                            <v-list-item 
                                v-if="items[0] && items[0].status_name === 'dispatched'"
                                @click="vEmit({ name: 'ReassignTech', data: selected })"
                            >
                                <v-list-item-title><v-icon color="blue" class="mr-2">how_to_reg</v-icon> Reassign Tech</v-list-item-title>
                            </v-list-item>
                            <v-list-item 
                                v-if="items[0] && items[0].status_name === 'dispatched'"
                                @click="vEmit({ name: 'ChangeDate', data: selected })"
                            >   
                                <v-list-item-title><v-icon color="orange" class="mr-2">event</v-icon> Change Date</v-list-item-title>
                            </v-list-item>
                            <v-list-item 
                                v-if="items[0] && items[0].status_name === 'dispatched'"
                                @click="vEmit({ name: 'SkipJob', data: selected })"
                            >
                                <v-list-item-title><v-icon color="orange" class="mr-2">redo</v-icon> Skip</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                v-if="displayAssignSkipped"
                                @click="vEmit({ name: 'RescheduleJob', data: selected })"
                            >
                                <v-list-item-title><v-icon color="blue" class="mr-2">loop</v-icon> Reschedule</v-list-item-title>
                            </v-list-item>
                      </v-list>
                    </v-menu>
                </v-layout>
                <div style="clear: both;"></div>
            </div>
            <v-card>
                <v-data-table
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        loader-height="2"
                        class="elevation-1 details-table"
                        hide-default-footer
                        mobile-breakpoint="100">
                    <template v-slot:item="{item}">
                       <tr>
                            <td>Job ID</td>
                            <td>
                                <strong v-if="!no_data.includes(item.id)">{{ item.id }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                        <tr>
                            <td>Status</td>
                            <td class="first-capital-letter">
                                <strong v-if="!no_data.includes(item.status_name)">{{ item.status_name }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                        <tr v-if="item.status_name === 'skipped'">
                            <td>Skip Reason</td>
                            <td class="first-capital-letter">
                                <strong v-if="!no_data.includes(item.skip_reason_title)">{{ item.skip_reason_title }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                        <tr>
                            <td>Client Name</td>
                            <td>
                                <strong v-if="!no_data.includes(item.full_name)">{{ item.full_name }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                        <tr>
                            <td>Assigned To</td>
                            <td>
                                <strong v-if="!no_data.includes(item.assigned_to_name)">{{ item.assigned_to_name }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                        <tr>
                            <td>Note To Client</td>
                            <td>
                                <strong v-if="!no_data.includes(item.note_for_client)">{{ item.note_for_client }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                        <tr>
                            <td>Note To Office</td>
                            <td>
                                <strong v-if="!no_data.includes(item.note)">{{ item.note }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                        <tr>
                            <td>Schedule Date</td>
                            <td>
                                <strong v-if="!no_data.includes(item.date)">{{ item.date }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                        <tr>
                            <td>Last Service Date</td>
                            <td>
                                <strong v-if="!no_data.includes(item.last_service_date)">{{ item.last_service_date }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                        <tr>
                            <td>Start Job Time</td>
                            <td>
                                <strong v-if="!no_data.includes(item.start_time)">{{ item.start_time }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                        <tr>
                            <td>Complete Job Time</td>
                            <td>
                                <strong v-if="!no_data.includes(item.end_time)">{{ item.end_time }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                        <tr>
                            <td>Estimated Time</td>
                            <td>
                                <strong v-if="!no_data.includes(item.estimate_time)">{{ item.estimate_time }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                        <tr>
                            <td>Spent Time</td>
                            <td>
                                <strong v-if="!no_data.includes(item.duration)">{{ item.duration }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                        <tr>
                            <td>Job Type</td>
                            <td class="first-capital-letter">
                                <strong v-if="!no_data.includes(item.type)">{{ titleCase(item.type) }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                        <tr>
                            <td>Service Plan</td>
                            <td>
                                <strong v-if="!no_data.includes(item.service_plan_name)">{{ item.service_plan_name }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                        <tr>
                            <td>Pricing Plan</td>
                            <td>
                                <strong v-if="!no_data.includes(item.pricing_plan_name)">{{ item.pricing_plan_name }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                        <tr>
                            <td>Address</td>
                            <td>
                                <strong v-if="!no_data.includes(item.address)">{{ item.address }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                        <tr>
                            <td>City</td>
                            <td>
                                <strong v-if="!no_data.includes(item.city)">{{ item.city }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>                       
                        <tr>
                            <td>Zip</td>
                            <td>
                                <strong v-if="!no_data.includes(item.zip)">{{ item.zip }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                        <tr>
                            <td>Revenue</td>
                            <td>
                                <strong v-if="!no_data.includes(item.price)">${{ item.price }}</strong>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
            <reassign-tech @done="backToPreviousPage" :staff="staff"></reassign-tech>
            <change-date @done="backToPreviousPage"></change-date>
            <skip-job @done="getDataFromApi"></skip-job>
            <reclean-job :staff="staff"></reclean-job>
            <delete-job @done="backToPreviousPage"></delete-job>
            <reschedule-job @done="backToPreviousPage" :staff="staff"></reschedule-job>
        </div>
    </v-app>
</template>

<script>
    import EventBus from '@/main'
    import ApiService from "@/common/api.service"
    import ReassignTech from "./ReassignTech"
    import ChangeDate from "./ChangeDate"
    import SkipJob from "./SkipJob"
    import RecleanJob from "./RecleanJob"
    import AddJob from "./AddJob"
    import DeleteJob from "./DeleteJob"
    import RescheduleJob from "./RescheduleJob"
    import AdjustPendingJob from "./AdjustPendingJob"
    import { mapActions } from 'vuex'

    export default {
        name: 'DispatchBoardShow',
        components: {
            ReassignTech,
            ChangeDate,
            SkipJob,
            RecleanJob,
            AddJob,
            DeleteJob,
            RescheduleJob,
            AdjustPendingJob
        },
        data() {
            return {
                items: [],
                items_id: [],
                selected: [],
                job_id: '',
                full_name: '',
                pricing_plan_name: '',
                service_plan_name: '',
                loading: true,
                no_data: [null, '', undefined, 'null'],
                headers: [
                    {
                        text: 'Details',
                        align: 'left',
                        sortable: false,
                        value: 'conditions',
                        width: '270px'
                    },
                    {
                        text: '',
                        value: 'results',
                        sortable: false
                    }
                ],
                staff: [],
                service_plan: '',
                days: [
                    { id: 1, name: 'Monday', short: 'Mon'},
                    { id: 2, name: 'Tuesday', short: 'Tue'},
                    { id: 3, name: 'Wednesday', short: 'Wed'},
                    { id: 4, name: 'Thursday', short: 'Thu'},
                    { id: 5, name: 'Friday', short: 'Fri'},
                    { id: 6, name: 'Saturday', short: 'Sat'},
                    { id: 7, name: 'Sunday', short: 'Sun'},
                ],
                bi_weeks: [
                    { id: 1, name: '1st and 3rd Week'},
                    { id: 2, name: '2nd and 4th Week'}
                ],
                weeks: [
                    { id: 1, name: '1st Week'},
                    { id: 2, name: '2nd Week'},
                    { id: 3, name: '3rd Week'},
                    { id: 4, name: '4th Week'}
                ],
                serverValidation: true,
                serverValidationMessage: 'Oops something went wrong...',
                server_errors: {}
            }
        },
        mounted() {
            this.getDataFromApi()
            this.staffList()
        },
        methods: {
            ...mapActions(['vEmit']),
            getDataFromApi(id = this.$route.params.id) {
                this.loading = true
                return new Promise((resolve, reject) => {
                    ApiService.get('/scheduler/job_show', {"job_id":id})
                        .then(response => {                            
                            let job_info = response.data.job_info
                            this.items = [job_info]
                            this.selected = [job_info]
                            this.job_id = job_info.id
                            this.full_name = job_info.full_name
                            this.pricing_plan_name = job_info.pricing_plan_name
                            this.service_plan_name = job_info.service_plan_name
                            this.loading = false
                        })
                        .catch(error => {
                            this.loading = false
                            console.log(error)
                        })
                })
            },
            staffList() {
                ApiService.get('/employee_select_list')
                    .then(response => {
                        this.staff = response.data.staff
                    })
                    .catch(err => {
                        console.log(err)
                    })
            },
            //Remove under score from string
            removeUnderScore(str){      
                for(let i in str){
                str = str.replace('_', ' ');                
                }      
                return str
            },
            makeCapitalFirstLetter(str){
                return str.charAt(0).toUpperCase() + str.slice(1)      
            },
            //Back to Previous page
            backToPreviousPage(){
                this.$router.push('/dispatch_board/')
            },
            titleCase(str = "") {
                return _.startCase(str.replace(/_/g, " "));
            },
            resetServerValidation() {
                this.serverValidation = true;
                this.serverValidationMessage = "Oops something went wrong...";
                this.server_errors = {};
            }
        },
        computed: {
            displayAssignSkipped () {
                if(this.selected.length > 0) {
                    return this.selected.every(i => {
                        return (i.status_name === 'missed' || i.status_name === 'skipped') && (i.type === 'initial' || i.type === 'one_time')
                    })
                } else return false
            }
        }
    }
</script>

<style scoped>
    /*Remove action controls form table*/
  .details-wrap .datatable__actions {
    display: none;
  }

  .upp {
    text-transform: uppercase;
  }

  .dialog-heading {
  background-color: #efefef;
  padding: 10px;
  }

  .first-capital-letter:first-letter {
      text-transform: capitalize
  }

  .job-status-missed {
    color: red;
  }

  .job-status-completed, .job-status-started {
      color: forestgreen;
  }
      
  .job-status-pending {
      color: #9e9e9e;
  }

  .job-status-dispatched {
    color: orange;
    }

  .job-status-skipped {
  color: #2196f3;
  }

  .subscriptions-status-text{
    text-transform: uppercase;
  }
</style>
